import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Loan } from '../schema';
import { ConfigStore } from '../stores/config';
import { LoanStore } from '../stores/store';
import getSource from '../utils/getSource';
import { isPrequalFunnel } from '../utils';

import { DEFAULT_THEME, BOAT_TRADER_SOURCE_ID, BUILD_ENV, PUBLIC_URL } from '../constants';
import { setThemeProperties } from '../theme/theme';

const makeLogoAbsolute = (logoUrl: string | undefined): string | undefined => {
  if (!logoUrl) return logoUrl;

  if (logoUrl.startsWith('http://') || logoUrl.startsWith('https://')) {
    return logoUrl;
  }

  if (BUILD_ENV === 'production') {
    return `https://live.dynamic-app.tridentfunding.com${logoUrl}`;
  }

  if (BUILD_ENV === 'stage') {
    return `https://qa.dynamic-app.tridentfunding.com${logoUrl}`;
  }

  return `${PUBLIC_URL}${logoUrl}`;
};

export const useTheme = (
  loanStore: LoanStore,
  config: ConfigStore | null,
  ignoreStatus: boolean = false,
  skip: boolean = false
) => {
  const { loan, theme, status } = loanStore;
  const history = useHistory();
  useEffect(() => {
    if (skip) return;
    if (config && (ignoreStatus || status === 'done') && theme == null) {
      let newTheme = DEFAULT_THEME;
      const { source, error } = getSource(config, loan as Loan);

      if (error) {
        history.push(
          isPrequalFunnel() ? `/pre-qualify/notFound/?source=${BOAT_TRADER_SOURCE_ID}` : '/notFound'
        );
      }

      if (source?.theme) {
        newTheme = {
          ...source.theme,
          logo: makeLogoAbsolute(source.theme.logo) || source.theme.logo,
          favicon: makeLogoAbsolute(source.theme.favicon) || source.theme.favicon,
        };
      }

      setThemeProperties(newTheme);
      loanStore.setTheme(newTheme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config, loan, skip]);

  return theme;
};
